import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../core/services/authentication.service';

@Component({
  selector: 'app-cabecera',
  templateUrl: './cabecera.component.html',
  styleUrls: ['./cabecera.component.css']
})
export class CabeceraComponent implements OnInit {
  @Input() title: string;
  @Input() description: string;
  @Input() padre: string;
  @Input() hijo: string;
  @Input() nieto: string;

  @Input() backButton = false;

  hasShowPriorNotice: boolean;

  constructor(private router: Router,
              private authService: AuthenticationService) { }

  ngOnInit() {
    this.authService.hasShowPriorNotice().subscribe(hasShowPriorNotice => this.hasShowPriorNotice = hasShowPriorNotice );
  }

  goBack() {
    window.history.back();
  }

  navigateProfile() {
    this.router.navigate(['docout', { outlets: { contenido: ['perfil'] } }]);
  }

  closeNotice() {
    this.hasShowPriorNotice = false;
    this.authService.closePriorNotice();
   }

}
